import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, Button, Spinner, Alert } from 'react-bootstrap';
import api from '../../../api/apiClient';

const PaymentSuccessPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const paymentId = searchParams.get('paymentId');

  const [isLoading, setIsLoading] = useState(true);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    const loadStatus = async () => {
      if (!paymentId) {
        setErrorMessage('Missing payment reference.');
        setIsLoading(false);
        return;
      }

      try {
        const response = await api.payments.getStatus(paymentId);
        setPaymentDetails(response.data?.data || null);
      } catch (error) {
        console.error('Failed to fetch payment details', error);
        setErrorMessage('Unable to load payment details.');
      } finally {
        setIsLoading(false);
      }
    };

    loadStatus();
  }, [paymentId]);

  if (isLoading) {
    return (
      <div className="text-center py-5">
        <Spinner animation="border" variant="success" />
        <p className="text-muted mt-3 mb-0">Confirming your payment...</p>
      </div>
    );
  }

  if (errorMessage) {
    return (
      <Alert variant="danger">
        <div className="d-flex align-items-center">
          <i className="fas fa-exclamation-circle me-2"></i>
          <span>{errorMessage}</span>
        </div>
      </Alert>
    );
  }

  return (
    <div className="container-fluid px-0">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold text-dark mb-1">Payment Successful</h4>
          <p className="text-muted mb-0">Your payment has been processed successfully. Welcome aboard!</p>
        </div>
      </div>

      <Card className="border-0 shadow-sm">
        <Card.Body className="p-4 text-center">
          <div className="d-inline-flex align-items-center justify-content-center rounded-circle bg-success bg-opacity-10 mb-3" style={{ width: '96px', height: '96px' }}>
            <i className="fas fa-check text-success" style={{ fontSize: '38px' }}></i>
          </div>
          <h4 className="fw-bold text-dark">Payment Successful!</h4>
          <p className="text-muted mb-4">
            Your payment has been received and the courses are now available in your learning space.
          </p>

          {paymentDetails && (
            <div className="border rounded p-3 text-start mx-auto mb-4" style={{ maxWidth: '520px' }}>
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Payment ID</span>
                <span className="fw-semibold">{paymentDetails.id}</span>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Transaction</span>
                <span className="fw-semibold">{paymentDetails.transactionId || 'Provided by gateway'}</span>
              </div>
              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Amount</span>
                <span className="fw-semibold">₹{Number(paymentDetails.amount || 0).toFixed(2)}</span>
              </div>
              <div className="d-flex justify-content-between">
                <span className="text-muted">Provider</span>
                <span className="fw-semibold text-uppercase">{paymentDetails.paymentType}</span>
              </div>
            </div>
          )}

          <div className="d-flex flex-column flex-md-row justify-content-center gap-3">
            <Button variant="success" className="fw-semibold px-4" onClick={() => navigate('/user/enrolled-courses')}>
              <i className="fas fa-book-reader me-2"></i>
              Go to My Courses
            </Button>
            <Button variant="outline-success" className="fw-semibold px-4" onClick={() => navigate('/user/courses')}>
              <i className="fas fa-plus-circle me-2"></i>
              Explore More Courses
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default PaymentSuccessPage;

